import { getSysMenu } from "utils/interface";
import { CQ } from "utils/commonQuest";

// 系统信息相关 包括： 系统菜单
export const sysInfo = {
  state: {
    // 系统菜单
    sysMenu: []
  },
  reducers: {
    // 更新系统菜单
    updateSysMenu(state, data: any) {
      return {
        ...state,
        sysMenu: data
      };
    }
  },
  effects: {
    // 获取系统菜单
    async getSysMenu(payload: any, rootState: any) {
      // 只有当系统菜单长度为0时才调用接口
      if (rootState.sysInfo.sysMenu.length === 0) {
        // 等待异步调用的结果
        const data = await CQ(getSysMenu());
        this.updateSysMenu(data);
      }
    }
  }
};
